import React from 'react';

const ApprovedWaybillsTableComponentLoadable = React.lazy(() => import('./ApprovedWaybillsTableComponent'))

export {
    ApprovedWaybillsTableComponentLoadable
}